import { useEffect, useState } from "react";

export const GeneratingText = ({ label = "Generating" }) => {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length >= 3 ? "" : prev + "."));
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <span style={{ display: "inline-block", minWidth: "90px" }}>
      {label}
      <span aria-hidden="true">{dots.padEnd(3, "\u00A0")}</span>
    </span>
  );
};
